import Vue from 'vue';
import { BASE_URL } from '@/api/const.js';

// const user = JSON.parse(localStorage.getItem("user"));

export default {
    // fetching calls list
    fetchCalls() {
        const user = JSON.parse(localStorage.getItem('user'));
        return Vue.http.get(BASE_URL + 'core/claim-list/', {
            headers: {
                Authorization: 'AlertButton ' + user.token,
            },
        });
    },

    fetchAllCars() {
        const user = JSON.parse(localStorage.getItem('user'));
        return Vue.http.get(BASE_URL + 'core/car/', {
            headers: {
                Authorization: 'AlertButton ' + user.token,
            },
        });
    },

    getAllClimes() {
        const user = JSON.parse(localStorage.getItem('user'));
        return Vue.http.get(BASE_URL + 'core/claim-list/', {
            headers: {
                Authorization: 'AlertButton ' + user.token,
            },
        });
    },

    assignСall(payload) {
        const user = JSON.parse(localStorage.getItem('user'));
        return Vue.http.post(BASE_URL + 'core/claim/', payload, {
            headers: {
                Authorization: 'AlertButton ' + user.token,
            },
        });
    },
};
